import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import Colors from 'src/core/utils/Colors';
import Fonts from 'src/core/utils/Fonts';
import Dimens from 'src/core/utils/Dimens';

interface FieldErrorProps {
	message: string;
}

/**
 * Inline validation message shown under a form field, matching the login forms (FormField): a small alert
 * icon followed by the message in the error colour.
 */
export default function FieldError({ message }: FieldErrorProps) {
	return (
		<View style={styles.row}>
			<Ionicons color={Colors.redError} name="alert-circle" size={14} style={styles.icon} />
			<Text style={styles.text}>{message}</Text>
		</View>
	);
}

const styles = StyleSheet.create({
	row: {
		flexDirection: 'row',
		alignItems: 'center',
		marginTop: Dimens.margin8,
		paddingHorizontal: Dimens.padding8,
	},
	icon: {
		marginRight: Dimens.margin4,
	},
	text: {
		fontSize: Dimens.fontSize12,
		fontFamily: Fonts.montserratRegular,
		color: Colors.redError,
	},
});
